var PdsLocations_1, QcEuPDS_1, QcType_1, QcCClegislation_1;
import { __decorate } from "tslib";
import { AsnArray, AsnProp, AsnPropTypes, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
let Iso4217CurrencyCode = class Iso4217CurrencyCode {
    constructor(value) {
        if (typeof value === "string") {
            this.alphabetic = value;
        }
        else if (typeof value === "number") {
            this.numeric = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.PrintableString })
], Iso4217CurrencyCode.prototype, "alphabetic", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.PrintableString })
], Iso4217CurrencyCode.prototype, "numeric", void 0);
Iso4217CurrencyCode = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], Iso4217CurrencyCode);
export { Iso4217CurrencyCode };
export class MonetaryValue {
    constructor(params = {}) {
        this.currency = new Iso4217CurrencyCode();
        this.amount = 0;
        this.exponent = 0;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: Iso4217CurrencyCode })
], MonetaryValue.prototype, "currency", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], MonetaryValue.prototype, "amount", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], MonetaryValue.prototype, "exponent", void 0);
let QcEuLimitValue = class QcEuLimitValue extends MonetaryValue {
};
QcEuLimitValue = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], QcEuLimitValue);
export { QcEuLimitValue };
let QcEuRetentionPeriod = class QcEuRetentionPeriod {
    constructor(value = 0) {
        this.value = value;
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], QcEuRetentionPeriod.prototype, "value", void 0);
QcEuRetentionPeriod = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], QcEuRetentionPeriod);
export { QcEuRetentionPeriod };
let PdsLocation = class PdsLocation {
    constructor(params = {}) {
        this.url = "";
        this.language = "";
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], PdsLocation.prototype, "url", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.PrintableString })
], PdsLocation.prototype, "language", void 0);
PdsLocation = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], PdsLocation);
export { PdsLocation };
let PdsLocations = PdsLocations_1 = class PdsLocations extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, PdsLocations_1.prototype);
    }
};
PdsLocations = PdsLocations_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: PdsLocation })
], PdsLocations);
export { PdsLocations };
let QcEuPDS = QcEuPDS_1 = class QcEuPDS extends PdsLocations {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, QcEuPDS_1.prototype);
    }
};
QcEuPDS = QcEuPDS_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: PdsLocation })
], QcEuPDS);
export { QcEuPDS };
let QcType = QcType_1 = class QcType extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, QcType_1.prototype);
    }
};
QcType = QcType_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.ObjectIdentifier })
], QcType);
export { QcType };
let QcCClegislation = QcCClegislation_1 = class QcCClegislation extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, QcCClegislation_1.prototype);
    }
};
QcCClegislation = QcCClegislation_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.PrintableString })
], QcCClegislation);
export { QcCClegislation };
export const id_etsi_qcs = "0.4.0.1862.1";
export const id_etsi_qcs_qcCompliance = `${id_etsi_qcs}.1`;
export const id_etsi_qcs_qcLimitValue = `${id_etsi_qcs}.2`;
export const id_etsi_qcs_qcRetentionPeriod = `${id_etsi_qcs}.3`;
export const id_etsi_qcs_qcSSCD = `${id_etsi_qcs}.4`;
export const id_etsi_qcs_qcPDS = `${id_etsi_qcs}.5`;
export const id_etsi_qcs_qcType = `${id_etsi_qcs}.6`;
export const id_etsi_qcs_qcCClegislation = `${id_etsi_qcs}.7`;
export const id_etsi_qct_esign = `${id_etsi_qcs_qcType}.1`;
export const id_etsi_qct_eseal = `${id_etsi_qcs_qcType}.2`;
export const id_etsi_qct_web = `${id_etsi_qcs_qcType}.3`;
